module.exports = __webpack_public_path__ + "img/3.456b3e5f.png";